<template>
  <div class="row">
    <div class="approval__block col-xs-12">
      <div class="approval__block__header">Therapietrouw</div>
      <div class="approval__block__content">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div v-if="!isPosa">
            <label :for="formConfig.ahi.ref"> AHI*: </label>
            <v-input-group-simple
              class="pt-4"
              v-model="formConfig.ahi.model"
              :initvalue="formConfig.ahi.model"
              :rule="formConfig.ahi.rule"
              :inputid="formConfig.ahi.ref"
              @blur="validateField"
            />
          </div>
          <div>
            <label :for="formConfig.avgHoursSleep.ref">
              Hoeveel uur slaapt de patiënt gemiddeld per nacht met het apparaat?*:
            </label>
            <v-select-group
              v-model="formConfig.avgHoursSleep.model"
              :selectid="formConfig.avgHoursSleep.ref"
              :error="formConfig.avgHoursSleep.error"
              :error-message="formConfig.avgHoursSleep.errorMessage"
              :rule="formConfig.avgHoursSleep.rule"
              :initselected="formConfig.avgHoursSleep.model"
              @change="select($event, 'avgHoursSleep')"
            >
              <option
                v-for="(avgHoursSleep, index) in osaDropDownDetails.avgHoursSleep"
                :key="'avgHoursSleep' + index"
                :data-index="avgHoursSleep"
                :value="avgHoursSleep"
              >
                &nbsp;&nbsp;&nbsp;{{ avgHoursSleep }}
              </option>
            </v-select-group>
          </div>
          <div>
            <label :for="formConfig.avgDaysSleep.ref">
              Hoeveel dagen per week slaapt de patiënt gemiddeld met het apparaat?*:
            </label>
            <v-select-group
              v-model="formConfig.avgDaysSleep.model"
              :selectid="formConfig.avgDaysSleep.ref"
              :error="formConfig.avgDaysSleep.error"
              :error-message="formConfig.avgDaysSleep.errorMessage"
              :rule="formConfig.avgDaysSleep.rule"
              :initselected="formConfig.avgDaysSleep.model"
              @change="select($event, 'avgDaysSleep')"
            >
              <option
                v-for="(avgDaysSleep, index) in osaDropDownDetails.avgDaysSleep"
                :key="'avgDaysSleep' + index"
                :data-index="avgDaysSleep"
                :value="avgDaysSleep"
              >
                &nbsp;&nbsp;&nbsp;{{ avgDaysSleep }}
              </option>
            </v-select-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useForm } from 'vee-validate';
import shared from '@/components/shared/shared';
import { ref } from 'vue';
import { from } from 'rxjs';
import { getOsaDropDownDetails } from '@/services';

export default {
  name: 'TherapyAdherence',
  components: {},
  props: {
    isPosa: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const user = ref(null);
    const osaDropDownDetails = ref([]);

    from(getOsaDropDownDetails()).subscribe((details) => {
      osaDropDownDetails.value = details;
    });
    return {
      user,
      osaDropDownDetails
    };
  },
  data() {
    const { validate } = useForm();

    return {
      validate,
      formConfig: {},
      data: { FileList: [] },
      OSADetails: {
        ahi: 0,
        avgHoursSleep: '',
        avgDaysSleep: '',
        isValid: false
      }
    };
  },

  created() {
    this.formConfig = {
      ahi: {
        model: this.OSADetails.ahi,
        ref: 'ahi',
        attached: true,
        alias: 'AHI',
        rule: {
          required: this.isPosa ? false : true,
          numeric: true,
          min: 0,
          max: 150
        },
        error: false
      },
      avgHoursSleep: {
        model: this.OSADetails.avgHoursSleep,
        ref: 'avgHoursSleep',
        attached: true,
        alias: 'Dit veld',
        rule: {
          required: true,
          numeric: true
        },
        error: false
      },
      avgDaysSleep: {
        model: this.OSADetails.avgDaysSleep,
        ref: 'avgDaysSleep',
        attached: true,
        alias: 'Dit veld',
        rule: {
          required: true,
          numeric: true
        },
        error: false
      }
    };
  },
  methods: {
    /**
     * @function saveOSADetails - Function to set the field values to the Store
     */
    async saveOSADetails(OSADetails) {
      const result = await this.validate();
      this.OSADetails.isValid = result.valid;
      this.OSADetails[OSADetails.key] = OSADetails.value;
      this.$emit('saveTherapyAdherence', this.OSADetails);
    },
    /**
     * @function validateField - Function to validate the value enterd according to the vee-validate
     */
    validateField(ref, model) {
      this.saveOSADetails({
        key: ref,
        value: model
      });

      this.saveButtonClicked = false;
    },
    /**
     * @function select - Funtion that handles the select change
     */
    select(e, key) {
      if (!e.currentTarget.value || e.currentTarget.value == 0) {
        return;
      }
      this.saveOSADetails({ key, value: parseInt(e.currentTarget.value, 10) });
    }
  }
};
</script>

<style lang="scss" scoped>
.approval {
  color: $grayish-very-dark;
  &__block {
    background-color: $white;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    margin: 0px 0px 30px 0px;
    &__header {
      background-color: $grayish-very-light;
      color: $grayish-very-dark;
      font-size: 18px;
      padding: 20px;
    }
    &__content {
      padding: 10px 10px 10px 10px;
    }
  }
  &__actions {
    display: flex;
    margin: 20px 0px 30px 0px;
    &__cancelApproval {
      margin-right: 25px;
    }
  }
  &__row {
    margin: 10px 0 10px 0;
    td {
      padding-bottom: 20px;
    }
  }
  &__bold {
    font-weight: bold;
  }
  &__cellDetail {
    padding: 5px 10px 5px 10px !important;
  }
  &__cell {
    color: $table-row-cell-color;
    font-size: $table-row-cell-font-size;
    line-height: $table-row-cell-line-height;
    justify-content: $table-row-cell-justify-content;
    padding: 16px 10px;
    vertical-align: $table-row-license-cell-vertical-align;
    @mixin list {
      list-style-type: none;
      padding: 0;
      margin: 0;
    }
    > .material-design-icon {
      display: flex;
      justify-content: center;
      fill: $black;
      :deep(svg) {
        display: block;
      }
    }
  }
  a {
    color: $teal-darkest;
    white-space: nowrap;
    text-decoration: none;
    cursor: pointer;
    margin-top: 10px;
    vertical-align: middle;
    font-size: 16px;
    font-weight: bold;
  }
  label {
    font-weight: 900;
    color: $gray-dark;
    margin-bottom: 15px;
  }
  :deep(.form-group) {
    width: 100%;
    padding-top: 0px;
  }
}
</style>
